if (!customElements.get('product-media')) {
  customElements.define(
    'product-media',
    class ProductMedia extends HTMLElement {
      constructor() {
        super();
        this.mainLayout = this.querySelector('[id^="GalleryViewer-"]');
      }

      get breakpoint() {
        return this.dataset.breakpoint
      }

      get thumbnailLayout() {
        return this.dataset.thumbnailLayout
      }

      connectedCallback() {
        const debouncedOnChange = debounce(() => this.setMediaMaxHeight(), ON_CHANGE_DEBOUNCE_TIMER);
        debouncedOnChange();
        window.addEventListener('resize', debouncedOnChange.bind(this));
      }

      setMediaMaxHeight() {
        if (this.thumbnailLayout == 'none' || this.thumbnailLayout == 'bottom') return;
        if (window.matchMedia(convertBreakpoint(this.breakpoint)).matches && this.mainLayout) this.style.setProperty('--media-max-height', `${this.mainLayout.offsetHeight}px`);
      }
    }
  );
}